import type { FC } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { Box, Grid, Heading, Stack } from '@eneco/sparky';
import { useContent } from '@sitecore/common';
import { CancelOrderRendering } from '@sitecore/types/CancelOrder';

const Banner: FC = () => {
  const { fields } = useContent<CancelOrderRendering>();

  return (
    <Box backgroundColor="backgroundSecondary" paddingY={16} paddingX={10}>
      <Grid columns={{ initial: 1, lg: 8 }}>
        <Grid.Item gridColumn={{ initial: '1/-1', md: '2/-4' }}>
          <Stack direction="column" gap={4}>
            <Heading size="XL" as="h2">
              {fields.data.title.value ?? 'Herroepingsform [not in sitecore]'}
            </Heading>
            <RichText html={fields.data.description.value ?? 'Beschrijving [not in sitecore]'} />
          </Stack>
        </Grid.Item>
      </Grid>
    </Box>
  );
};

export default Banner;
